module.exports = __webpack_public_path__ + "static/media/ios-gift.e1918564.svg";